module.exports = {"TXTCLI_Available":{"id":"TXTCLI_Available","defaultMessage":"Saldo"},"TXTCLI_Expires":{"id":"TXTCLI_Expires","defaultMessage":"Udløber"}}